import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import Lottie from "lottie-react";

  export const LottieIndicator = (data: {data: any, message: string}) => {
    console.log(data.data)
    return (
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "transparent",
          padding: "20px",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          borderRadius: "8px",
        }}
      >
        {data.data ?
          <Lottie
            animationData={data["data"]}
            allowTransparency={true}
            style={{ width: 150, height: 150 }}
          />
          :<div />
        }

        <Typography
          variant="subtitle2"
          sx={{
            color: "#6c757d",
            textAlign: "center",
            marginTop: "20px",
          }}
        >
          {data.message}
        </Typography>
      </Box>
    );
  };